import React from 'react';

/**
 * PageHero — reusable hero block for legal/static pages.
 * Matches the visual identity of /a-propos-de-nous, /abonnements, /nos-partenaires.
 *
 * Props:
 *  - title:    main h1 string (required)
 *  - subtitle: optional secondary text (string or ReactNode)
 */
const PageHero = ({ title, subtitle }) => (
  <section className="pt-20">
    <div className="py-16 lg:py-20 bg-gradient-to-br from-[#e8f5ef] via-[#f0f9f4] to-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 animate-in fade-in slide-in-from-bottom duration-700">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed animate-in fade-in slide-in-from-bottom duration-700 delay-100">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  </section>
);

export default PageHero;
